import { audiencePathResources } from "./Pages/audiencePaths";

/**
 * Audience metadata source of truth.
 *
 * Current behavior:
 * - Core title/description maps are aligned with Spotlight route/title matching.
 * - `_PATCH` values are temporary UI overrides for header/sub-nav copy where parity is still needed.
 *
 * Direction:
 * - Consolidate into a single product-approved metadata set so Spotlight, headers, and sub-nav labels match.
 */

export const AUDIENCE_SUB_NAV_TITLES = {
    [audiencePathResources.contacts]: "Contacts",
    [audiencePathResources.segments]: "Segments",
} as const;

export const AUDIENCE_SUB_PAGE_TITLES = {
    [`${audiencePathResources.segments}/new`]: "Create Segment",
} as const;

export const AUDIENCE_PAGE_DESCRIPTIONS = {
    [audiencePathResources.contacts]: "Audience analytics dashboard for customer insights and segmentation.",
    [audiencePathResources.segments]:
        "Customer segmentation management system for creating and managing customer groups.",
    [`${audiencePathResources.segments}/new`]:
        "Interface for creating and modifying customer segment criteria and rules.",
} as const;

// Header/sub-nav title overrides used where page labels differ from base metadata.
export const AUDIENCE_SUB_PAGE_TITLES_PATCH = {
    [`${audiencePathResources.segments}/new`]: "New Segment",
} as const;
